/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferralRecipientConfig } from './ReferralRecipientConfig';
import {
    ReferralRecipientConfigFromJSON,
    ReferralRecipientConfigFromJSONTyped,
    ReferralRecipientConfigToJSON,
    ReferralRecipientConfigToJSONTyped,
} from './ReferralRecipientConfig';

/**
 * 
 * @export
 * @interface CreateReferralRecipientConfig201Response
 */
export interface CreateReferralRecipientConfig201Response {
    /**
     * 
     */
    data?: ReferralRecipientConfig;
}

/**
 * Check if a given object implements the CreateReferralRecipientConfig201Response interface.
 */
export function instanceOfCreateReferralRecipientConfig201Response(value: object): value is CreateReferralRecipientConfig201Response {
    return true;
}

export function CreateReferralRecipientConfig201ResponseFromJSON(json: any): CreateReferralRecipientConfig201Response {
    return CreateReferralRecipientConfig201ResponseFromJSONTyped(json, false);
}

export function CreateReferralRecipientConfig201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReferralRecipientConfig201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ReferralRecipientConfigFromJSON(json['data']),
    };
}

export function CreateReferralRecipientConfig201ResponseToJSON(json: any): CreateReferralRecipientConfig201Response {
    return CreateReferralRecipientConfig201ResponseToJSONTyped(json, false);
}

export function CreateReferralRecipientConfig201ResponseToJSONTyped(value?: CreateReferralRecipientConfig201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ReferralRecipientConfigToJSON(value['data']),
    };
}

